import { createContext, type ReactNode } from 'react';

import { DEFAULT_CUSTOM_TOOLTIP_CONFIG } from '../../core/constants.js';
import type { ChartTooltipConfig } from '../../core/types/tooltip.js';
import { XYChartTooltipPayload } from '../types/xy-chart.js';

export interface XYChartCustomTooltipConfig extends ChartTooltipConfig {
  template?: (tooltipPayload: XYChartTooltipPayload) => ReactNode;
}

export { DEFAULT_CUSTOM_TOOLTIP_CONFIG };

export const XYChartCustomTooltipContext =
  createContext<XYChartCustomTooltipConfig>(DEFAULT_CUSTOM_TOOLTIP_CONFIG);
